import React, { useState, useEffect } from 'react';
import { useUserContext } from '@fff-web/fff-utilities';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { trackPageLoad } from '@fff-web/fff-analytics';
import Layout from '../../components/Layout';
import AllErrorMessage from '../../components/AllErrorMessage';
import useLaunchDarkly from '../../hooks/useLaunchDarkly';
import MainBanner from './MainBanner';
import PerksBanner from './PerksBanner';
import ReactivateTodayDisclaimer from './ReactivateTodayDisclaimer';
import { searchToObject } from '../../helpers';

import styles from './ReactivateToday.module.scss';
import { redirectToBaseSite } from '../../utils/redirectMethods';

export const ReactivateToday = ({ ldClient, location: { search } }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const { userInfo } = useUserContext();
  useLaunchDarkly(ldClient, userInfo);
  const { coupon_code: couponCode } = searchToObject(search);

  const isCanceled = userInfo && userInfo.user && userInfo.user.subscriptionState === 'CANCELED';

  useEffect(() => {
    if (isCanceled) {
      trackPageLoad({
        properties: { coupon_code: couponCode },
      }).then();
    }
  }, []);

  if (!isCanceled) {
    redirectToBaseSite();
    return null;
  }

  return (
    <Layout
      isLoading={isLoading}
      pageTitle="Reactivate Today"
      showError={showRetry}
      ErrorComponent={() => (
        <AllErrorMessage subjectAction="reactivate" onButtonClick={() => setShowRetry(false)} />
      )}
    >
      <MainBanner isLoading={isLoading} setIsLoading={setIsLoading} setShowRetry={setShowRetry} />
      <div className={styles.divider} />
      <PerksBanner />
      <ReactivateTodayDisclaimer
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setShowRetry={setShowRetry}
      />
    </Layout>
  );
};

export default withLDConsumer()(ReactivateToday);
